<template>
    <div :class="`convention-teaser ${mode}`">
        <convention-teaser-tools
            v-if="user && mode == 'dashboard'"
            :parentConvention="parentConvention"
            :user="user"
        />
        <convention-teaser-content
            :mode="mode"
            :convention="parentConvention"
            :selectedVariantNumber="
                isSelected(parentConvention) && selectedConvention.variantNumber
            "
            :selected="isSelected(parentConvention)"
        />
        <div class="children">
            <convention-teaser-content
                v-for="childConvention in children"
                :key="childConvention._ui"
                :child="true"
                :mode="mode"
                :convention="childConvention"
                :selectedVariantNumber="
                    isSelected(childConvention) && selectedConvention.variantNumber
                "
                :selected="isSelected(childConvention)"
            />
        </div>
        <action
            v-if="
                showAll == false &&
                parentConvention.childrenConventions &&
                parentConvention.childrenConventions.length > 1
            "
            class="show-all"
            name="link"
            :nochevron="true"
            @click="showAll = true"
        >
            <typo name="body-14-light">Afficher toutes les conventions rattachées</typo>
        </action>
    </div>
</template>

<script>
import ConventionTeaserTools from "./ConventionTeaserTools.vue";
import ConventionTeaserContent from "./ConventionTeaserContent.vue";
import { EventBus } from "src/bus/eventBus";

import { filter } from "lodash";

export default {
    components: { ConventionTeaserContent, ConventionTeaserTools },
    props: ["parentConvention", "selectedConvention", "mode", "user"],
    mounted() {
        EventBus.$on("convention:will-print", () => {
            this.showAll = true;
        });
    },
    destroyed() {
        EventBus.$off("convention:will-print");
    },
    data() {
        return {
            showAll: false,
        };
    },
    methods: {
        isSelected(convention) {
            return (
                this.selectedConvention &&
                convention.conventionId == this.selectedConvention.conventionId
            );
        },
    },
    computed: {
        children() {
            if (this.showAll) {
                return this.parentConvention.childrenConventions;
            }
            return filter(this.parentConvention.childrenConventions, (c, index) => {
                if (this.isSelected(this.parentConvention) && index == "0") {
                    return true;
                }
                return this.isSelected(c);
            });
        },
    },
};
</script>

<style lang="sass" scoped>
.convention-teaser
    position: relative
    &.dashboard
        margin:0 0 $grid-gutter*2 0

.show-all
    position: relative
    padding-left: 12px
    padding-top: 5px
    &:before
        content: ""
        border-left: 3px solid $color-secondary
        left: 0px
        top: 0px
        bottom: 0px
        width: 1px
        position: absolute
        opacity: 0.3

.remove
    display: flex
    justify-content: flex-end
    margin-bottom: 10px
</style>
